const routes = JSON.parse(document.querySelector('body').dataset.routes);
export const currentRoute = document.querySelector('body').dataset.route;
export const path = (route, params) => {
    let generatedPath = route;
    Object.entries(params).forEach(([key, value]) => {
        generatedPath = generatedPath.replace(`__${key}__`, value.toString());
    });
    return generatedPath;
};
export default routes;
